import { useAppSelector } from "@/hooks/redux";
import { selectRouteById } from "@/store/slices/manager";

export const useRouteSelector = (routeId: string) =>
    useAppSelector((state) => selectRouteById(state, routeId));
